var render = function render(_c,_vm){return _c('div',_vm._g({ref:_vm.data.ref,staticClass:"pill flex",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},_vm.listeners),[_c('div',{staticClass:"pill__content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"pill__content pill__content--notch"},[_vm._t("notch")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }